import { FC, PropsWithChildren } from 'react';

import '../input.scss';

const Error: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return <span className="error-msg mt-1 text-xs capitalize-first">{children}</span>;
};

export default Error;
